import React from 'react';

const WashesPlus = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.259 26">
        <g fill="currentColor" fillRule="evenodd">
            <path
                fillRule="nonzero"
                stroke="currentColor"
                d="M11.591 10.13a.38.38 0 0 0-.6 0c-.2.254-4.903 6.288-5.114 9.6a6.106 6.106 0 0 0 1.642 4.547C8.546 25.372 9.921 26 11.291 26c1.422 0 2.824-.629 3.847-1.725 1.13-1.21 1.686-2.826 1.567-4.547-.23-3.31-4.915-9.343-5.114-9.599Zm2.99 13.626c-.88.942-2.078 1.482-3.29 1.482-1.16 0-2.333-.54-3.217-1.482a5.342 5.342 0 0 1-1.437-3.978c.167-2.62 3.605-7.388 4.653-8.785 1.045 1.398 4.473 6.166 4.655 8.788.105 1.508-.38 2.92-1.364 3.975ZM6.29 12.037c.764-.819 1.14-1.91 1.06-3.073-.153-2.203-3.24-6.18-3.372-6.348a.38.38 0 0 0-.6 0C3.249 2.783.149 6.76.009 8.965a4.125 4.125 0 0 0 1.109 3.073c.696.742 1.63 1.168 2.562 1.168.967 0 1.919-.427 2.612-1.17Zm-2.612.408c-.722 0-1.454-.338-2.007-.927a3.361 3.361 0 0 1-.905-2.503C.87 7.415 2.9 4.533 3.68 3.482 4.455 4.534 6.48 7.417 6.59 9.017c.066.95-.238 1.838-.857 2.5-.55.59-1.299.928-2.055.928Z"
            />
            <path d="M22.135 4.124v-2.1a2.023 2.023 0 1 0-4.046 0v2.1h-2.101a2.023 2.023 0 1 0 0 4.046h2.1v2.101a2.023 2.023 0 1 0 4.047 0v-2.1h2.1a2.023 2.023 0 1 0 0-4.047h-2.1Z" />
        </g>
    </svg>
);

export default WashesPlus;
